export default __webpack_public_path__ + "static/media/About_BG-07.1c87f9fb.png";